/**
 * Nexhance AI's public Supabase project endpoint.
 *
 * The project URL is not a secret, so we pin it in source to prevent a typo in
 * a hosting environment variable from breaking authentication in production.
 * If the app is ever migrated to a different Supabase project, update this one
 * constant and the Google OAuth redirect URI together.
 */
export const NEXHANCE_SUPABASE_PROJECT_REF = 'dnecirirceaouatfpaee';
export const NEXHANCE_SUPABASE_URL = `https://${NEXHANCE_SUPABASE_PROJECT_REF}.supabase.co`;
export const NEXHANCE_SUPABASE_GOOGLE_CALLBACK_URL = `${NEXHANCE_SUPABASE_URL}/auth/v1/callback`;
